import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Participante } from './participante';
import { ParticipanteService } from './participante.service';
import { Usuario } from './../usuario/usuario';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Upload } from '../uploads/upload';

declare var Materialize:any;
declare var $: any;
@Component({
  selector: 'app-editar-participante',
  templateUrl: './editar-participante.component.html',
  providers: [ParticipanteService, Usuario]
})

export class EditarParticipanteComponent implements OnInit, AfterViewChecked {

  participante: Participante;
  public titulo: string = "Participante"; 
  public busy: Promise<any>;
  public certificadoSelecionado: any = null;


  constructor(
    private participanteService: ParticipanteService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private usuario: Usuario,
    private route: ActivatedRoute,
  ) { 
    this.participante = new Participante();
  }

  getParticipante(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];
      if(id !== undefined ){

        this.busy = this.participanteService.getParticipante(id)
          .then((participante) => this.exibir(participante));
      }
    });
  }

  exibir(participante: any): void{
    this.participante = participante;
  }

  salvar(): void {
    if(this.participante.id){
      this.busy = this.participanteService.atualizarParticipante(this.participante)
          .then(() => this.goBack());
    }
  }

  goBack(): void {
    this.router.navigate(['/participantes']);
 }

 confirmaEnvio(participanteId: number, uploadId: number) {
  if(confirm("Você deseja realmente enviar o Certificado por e-mail para este participante?")) {
      this.agendar(participanteId,uploadId);
  }
}

agendar(participanteId: number, uploadId: number): void {
  this.busy = this.participanteService.agendar(participanteId, uploadId);
}

apagar(participante: Participante, upload: Upload): void {
  if(confirm('Deseja realmente excluir esse participante? Essa operação não pode ser revertida após a confirmação.')){
    this.busy = this.participanteService.deleteParticipante(participante.id, upload.upload_id)
          .then(() => this.getParticipante());
  }
}

abrirModalTransferencia(certificado: any): void {
  this.certificadoSelecionado = certificado;
  setTimeout(() => {
    $('#modal-transferir-certificado').modal('open');
  }, 100);
}

onTransferenciaConcluida(): void {
  // Recarregar dados do participante após transferência
  this.getParticipante();
  this.certificadoSelecionado = null;
}

  ngOnInit() {
    this.getParticipante();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/participantes/editar-participante.component.ts